<h2 mat-dialog-title>{{ 'TEMPLATES.IMPORT_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content>
  <div class="form-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'TEMPLATES.IMPORT_DIALOG.SELECT_TEMPLATE' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedTemplateId">
        @for (template of templateList; track template.id) {
        <mat-option [value]="template.id"> {{ template.name }} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (templateList.length === 0) {
    <p class="no-templates-message">{{ 'TEMPLATES.IMPORT_DIALOG.NO_TEMPLATES' | translate }}</p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="onImport()" [disabled]="isImportDisabled" cdkFocusInitial>
    {{ 'TEMPLATES.IMPORT_DIALOG.IMPORT' | translate }}
  </button>
</mat-dialog-actions>
